var _rect, _rect2, _rect3, _path;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgBarChart = function SvgBarChart(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    rx: 10,
    fill: "#1C275E",
    fillOpacity: 0.05
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    rx: 10,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 49,
    height: 49,
    rx: 9.5,
    stroke: "#2E48F3",
    strokeOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.8858 24.8858H12.2572C11.4001 24.8858 10.7144 25.5715 10.7144 26.4286V35.8001C10.7144 36.6572 11.4001 37.3429 12.2572 37.3429H16.8858C17.7429 37.3429 18.4286 36.6572 18.4286 35.8001V26.4286C18.4286 25.5715 17.7429 24.8858 16.8858 24.8858ZM27.3429 21.2858H22.7144C21.8572 21.2858 21.1715 21.9715 21.1715 22.8286V35.8001C21.1715 36.6572 21.8572 37.3429 22.7144 37.3429H27.3429C28.2001 37.3429 28.8858 36.6572 28.8858 35.8001V22.8286C28.8286 21.9715 28.1429 21.2858 27.3429 21.2858ZM37.7429 12.7144H33.1144C32.2572 12.7144 31.5715 13.4001 31.5715 14.2572V35.8001C31.5715 36.6572 32.2572 37.3429 33.1144 37.3429H37.7429C38.6001 37.3429 39.2858 36.6572 39.2858 35.8001V14.2001C39.2858 13.4001 38.6001 12.7144 37.7429 12.7144Z",
    fill: "#2E48F3"
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBarChart, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/bar-chart.2466d360.svg";
export { ForwardRef as ReactComponent };